import { NgModule } from '@angular/core';
import { UtilCryptography } from 'src/app/5.transversal/5.2.utils/util.cryptography/util.cryptography';
import { UtilApplication } from 'src/app/5.transversal/5.2.utils/util.application/util.application';

@NgModule({
    providers: [
        UtilCryptography,
        UtilApplication
    ]
})
export class AppProviderUtils { }